export const GET_SP_SUGGESTIONS_SUCCEED = 'GET_SP_SUGGESTIONS_SUCCEED'
export const GET_SD_SUGGESTIONS_SUCCEED = 'GET_SD_SUGGESTIONS_SUCCEED'
